import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { theme } from './theme';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// TODO: Replace with your Auth0 domain and client ID
const auth0Domain = 'YOUR_AUTH0_DOMAIN';
const auth0ClientId = 'YOUR_AUTH0_CLIENT_ID';

root.render(
  <Auth0Provider
    domain={auth0Domain}
    clientId={auth0ClientId}
    authorizationParams={{
      redirect_uri: window.location.origin + '/callback', // Or your specific callback URL
    }}
    cacheLocation="localstorage" // Recommended for better performance and user experience
  >
    <ChakraProvider theme={theme}>
      <BrowserRouter future={{ v7_startTransition: true }}>
        <App />
      </BrowserRouter>
    </ChakraProvider>
  </Auth0Provider>
);

reportWebVitals();
